/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type FollowSearchButton_favoritesConnection$ref = any;
type PdpSharedAffirm_user$ref = any;
type PdpSharedContactDealerButton_user$ref = any;
type PdpSharedMakeOfferButton_user$ref = any;
export type PdpRespSidebarButtons_user$ref = any;
export type PdpRespSidebarButtons_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly favorites?: {
        readonly " $fragmentRefs": FollowSearchButton_favoritesConnection$ref;
    } | null;
    readonly " $fragmentRefs": PdpSharedContactDealerButton_user$ref & PdpSharedMakeOfferButton_user$ref & PdpSharedAffirm_user$ref;
    readonly " $refType": PdpRespSidebarButtons_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespSidebarButtons_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "followSearchPages",
            "type": "[String]"
        },
        {
            "kind": "RootArgument",
            "name": "fetchFollowSearch",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedContactDealerButton_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedMakeOfferButton_user",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedAffirm_user",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchFollowSearch",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favorites",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        },
                        {
                            "kind": "Variable",
                            "name": "pages",
                            "variableName": "followSearchPages"
                        },
                        {
                            "kind": "Literal",
                            "name": "types",
                            "value": [
                                "SEARCH"
                            ]
                        }
                    ],
                    "concreteType": "favoritesConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "FollowSearchButton_favoritesConnection",
                            "args": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '560d549862823755ff32b99c9f0190d8';
export default node;
